import Vue from 'vue';
import Paginator from 'primevue/paginator';

Vue.component('Paginator', Paginator);
